import {IFileUploadService} from "./IFileUploadService";
import {HttpClient, HttpHeaders, HttpResponse} from "@angular/common/http";
import {ApiAccessService} from "../../infrastructure/api/ApiAccessService";
import {FileUploadMetadata} from "../../../../../server/src/base/entities/FileUploadMetadata";

export class S3BucketUploadService implements IFileUploadService{

    constructor(private apiAccessService:ApiAccessService, private http:HttpClient) {

    }


    Upload(file:File): Promise<string> {
        let fileUploadMetadata:FileUploadMetadata = new FileUploadMetadata();
        fileUploadMetadata.name = file.name;
        fileUploadMetadata.type = file.type;
        return this.apiAccessService.PostReturn<FileUploadMetadata>('employee/upload', fileUploadMetadata).then(metadata => {
            return this.UploadFileToS3(file, metadata).catch(err => {
                console.error("Cannot upload file");
                throw err;
            });
        })
    }

    private UploadFileToS3(picture:File, metadata:FileUploadMetadata):Promise<string>{
        let headers = new HttpHeaders();
        headers = headers.set("Content-Type", metadata.type);
        return this.http.put(metadata.uploadUrl, picture, { headers:headers, observe: 'response'}).toPromise().then((response) => {
            let pictureUrl = this.ExtractUrl(response);
            console.log('File ' + picture.name + ' uploaded to ' + pictureUrl);
            return pictureUrl;
        });
    }

    private ExtractUrl(response:HttpResponse<any>):string{
        let url = response.url;
        return url.substring(0, url.indexOf('?'))
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/files/S3BucketUploadService.ts